export function modal() {
  const modalRoots = document.querySelectorAll(".c-modal");
  if (modalRoots.length === 0) {
    return;
  }

  const html = document.documentElement;
  const body = document.body;
  let openCount = 0;
  const wrapperMap = new Map();

  function lockScroll() {
    openCount += 1;
    if (openCount === 1) {
      html.style.overflow = "hidden";
      body.style.overflow = "hidden";
    }
  }

  function unlockScroll() {
    openCount = Math.max(0, openCount - 1);
    if (openCount === 0) {
      html.style.removeProperty("overflow");
      body.style.removeProperty("overflow");
    }
  }

  function showWrap(wrap) {
    wrap.style.display = "block";
    wrap.style.opacity = "0";
    wrap.style.transition = "opacity 200ms ease";
    requestAnimationFrame(() => {
      wrap.style.opacity = "1";
    });

    const container = wrap.querySelector(".c-modal__container");
    if (container) {
      container.scrollTop = 0;
    }

    lockScroll();
  }

  function hideWrap(wrap) {
    unlockScroll();
    wrap.style.transition = "opacity 200ms ease";
    wrap.style.opacity = "0";
    window.setTimeout(() => {
      wrap.style.display = "none";
      wrap.style.opacity = "";
      wrap.style.transition = "";
    }, 200);
  }

  modalRoots.forEach((root) => {
    if (!root.dataset.modalRoot) {
      root.dataset.modalRoot = String(Math.random()).slice(2);
    }

    root.querySelectorAll(".c-modal__wrapper").forEach((wrap) => {
      const modalId = wrap.getAttribute("data-modal");
      if (!modalId) {
        return;
      }

      wrapperMap.set(`${root.dataset.modalRoot || root}-${modalId}`, wrap);
      body.appendChild(wrap);

      wrap.addEventListener("click", (e) => {
        const closer = e.target.closest(".c-modal__layer, .c-modal__close");
        if (!closer) {
          return;
        }
        e.preventDefault();
        hideWrap(wrap);
      });
    });

    root.addEventListener("click", (e) => {
      const trigger = e.target.closest(".c-modal__trigger");
      if (!trigger || !root.contains(trigger)) {
        return;
      }

      e.preventDefault();
      const modalId = trigger.getAttribute("data-modal");
      if (!modalId) {
        return;
      }

      const target = wrapperMap.get(`${root.dataset.modalRoot}-${modalId}`);
      if (!target) {
        return;
      }

      showWrap(target);
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") {
      return;
    }

    wrapperMap.forEach((wrap) => {
      if (getComputedStyle(wrap).display !== "none") {
        hideWrap(wrap);
      }
    });
  });
}
